import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-clinical-blue pt-12 pb-8 sm:pt-20 sm:pb-10 text-white" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="grid lg:grid-cols-4 gap-10 sm:gap-12 mb-12 sm:mb-20" data-id="element-44">
          <div className="lg:col-span-1" data-id="element-45">
            <span className="text-xl sm:text-2xl font-black tracking-tight text-white uppercase block mb-4 sm:mb-6" data-id="element-46">
              Daily Care Pharmacy
            </span>
            <p className="text-blue-100 text-sm leading-relaxed max-w-xs" data-id="element-47">
              Your trusted local digital pharmacy, providing professional care
              and wellness essentials to our communities.
            </p>
          </div>

          <div data-id="element-48">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-49">
              Annapolis Store
            </h4>
            <div className="space-y-6" data-id="element-50">
              <p className="text-white text-base font-medium" data-id="element-51">
                2002 Jennifer Rd
                <br data-id="element-52" />
                Annapolis, MD 21401
              </p>
              <div className="text-sm text-blue-100 space-y-1" data-id="element-53">
                <p data-id="element-54">Mon - Fri: 9:00 AM - 7:00 PM</p>
                <p data-id="element-55">Sat: 10:00 AM - 4:00 PM</p>
                <p data-id="element-56">Sun: Closed</p>
              </div>
              <a href="#" className="text-white font-bold text-xs uppercase tracking-widest hover:underline flex items-center gap-2" data-id="element-57">
                Google Business Profile <ExternalLinkIcon className="w-4 h-4" data-id="element-58" />
              </a>
            </div>
          </div>

          <div data-id="element-59">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-60">
              Washington D.C. Store
            </h4>
            <div className="space-y-6" data-id="element-61">
              <p className="text-white text-base font-medium" data-id="element-62">
                1234 Pennsylvania Ave NW
                <br data-id="element-63" />
                Washington, D.C. 20004
              </p>
              <div className="text-sm text-blue-100 space-y-1" data-id="element-64">
                <p data-id="element-65">Mon - Fri: 8:30 AM - 6:30 PM</p>
                <p data-id="element-66">Sat: 10:00 AM - 2:00 PM</p>
                <p data-id="element-67">Sun: Closed</p>
              </div>
              <a href="#" className="text-white font-bold text-xs uppercase tracking-widest hover:underline flex items-center gap-2" data-id="element-68">
                Google Business Profile <ExternalLinkIcon className="w-4 h-4" data-id="element-69" />
              </a>
            </div>
          </div>

          <div data-id="element-70">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-71">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-72">
              <li data-id="element-73">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-74">
                  Prescriptions
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-76">
                  OTC Products
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-78">
                  Vaccines
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="text-blue-200 text-sm font-bold uppercase tracking-widest hover:underline" data-id="element-80">
                  The VIEW (DC Admin)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-81">
          <p className="text-blue-200 text-xs font-bold uppercase tracking-widest" data-id="element-82">
            © 2026 DAILY CARE PHARMACY.
          </p>
          <div className="flex gap-8" data-id="element-83">
            <Link to="/privacy" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-84">
              Privacy
            </Link>
            <Link to="/terms" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-85">
              Terms
            </Link>
            <Link to="/hipaa" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-86">
              HIPAA
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}